function SkipLink() {
  return (
    <a
      href='#main-content'
      className='bg-black text-white absolute left-0 -translate-y-full px-4 py-2 focus:z-[100] focus:translate-y-0'
    >
      Skip to main content
    </a>
  )
}

export { SkipLink }
